import { ref, get, set } from 'firebase/database';
import { database } from '../firebaseConfig';

// Shared list of utility and service providers, kept separate from partners.
// Built automatically: a provider is added the first time someone confirms it on a transaction.
// Stored at serviceProviders/{categoryKey}/{id} = { name, lastUsed }.

const keyOf = (name) => String(name || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const loadServiceProviders = async () => {
  try {
    const snap = await get(ref(database, 'serviceProviders'));
    return snap.exists() ? snap.val() : {};
  } catch (err) {
    console.error('Failed to load service providers', err);
    return {};
  }
};

// Returns an array of provider names for one category, most recently used first.
export const providersForCategory = (all, categoryKey) => {
  const entries = Object.values((all || {})[categoryKey] || {});
  return entries
    .sort((a, b) => (b.lastUsed || 0) - (a.lastUsed || 0))
    .map((e) => e.name);
};

// Saves a confirmed provider so it shows up for everyone next time. Existing names are only refreshed.
export const rememberProvider = async (categoryKey, name) => {
  const clean = String(name || '').trim();
  if (!clean) return;
  const id = keyOf(clean);
  if (!id) return;
  try {
    await set(ref(database, `serviceProviders/${categoryKey}/${id}`), { name: clean, lastUsed: Date.now() });
  } catch (err) {
    console.error('Failed to save service provider', err);
  }
};
